import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch } from '../../../../../utils';
import { toast } from '../../../../../utils';
import axios from 'axios';

const TABLE_HEADER = [
  {
    header: 'Medicine Name',
    accessor: (row) => row?.product?.main?.name
  }
];

export const MedicineDetailForm = ({ onClose, onAdd, medicine }) => {
  console.log('EHLLO THE MEDICINE DATA IS HERE', medicine);
  const [inputs, setInputs] = useState('');
  const [originalMedicineData, setOriginalMedicineData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [totalStocks, setTotalStocks] = useState(0);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        medicine: Yup.string().required('Please select Medicine')
      })
    ),
    defaultValues: {
      quantity: 1
    },
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    const medicineDetail = medicine.find((detail) => detail.product.main?.name === formValues.medicine);
    const medicineId = medicineDetail?.product._id || '';
    const rate = medicineDetail?.rate || '';
    const expDate = medicineDetail?.exp_date || '';
    const batchNo = medicineDetail?.batch_no || '';
    const hsnCode = medicineDetail?.hsn_code || '';
    const gst = medicineDetail?.gst || '';
    const transformedValues = {
      ...formValues,
      medicine: medicineId,
      rate: rate,
      exp_date: expDate,
      batch_no: batchNo,
      hsn_code: hsnCode,
      gst: gst
    };
    console.log('HELLO TRANSFORMED VALUES', transformedValues);
    onAdd(transformedValues);
  };

  useEffect(() => {
    if (medicine && Array.isArray(medicine) && medicine.length > 0) {
      setOriginalMedicineData(medicine);
      setIsFiltered(false);
    }
  }, [medicine]);

  useEffect(() => {
    handleProductSearch(inputs);
  }, [inputs]);

  const handleProductSearch = (searchInput) => {
    if (Array.isArray(medicine)) {
      const lowercasedInput = searchInput.toLowerCase();
      const filtered = medicine.filter((item) => {
        const Match = item.product && item.product?.main?.name?.toString().toLowerCase().includes(lowercasedInput);
        return Match;
      });

      setOriginalMedicineData(filtered);
      setIsFiltered(true);
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInputs(newInput);
  };

  const fetchStock = async (rowId) => {
    try {
      const response = await axios.get(`${BASE_URL}/stock-master/total?name=${rowId}`);

      if (response?.data?.success) {
        const totalQuantity = response.data.data;
        const totalQuantitySum = totalQuantity.reduce((sum, item) => sum + item.totalQuantity, 0);
        setTotalStocks(totalQuantitySum);
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setTotalStocks({ loading: false, data: [] });
      }
    } catch (error) {
      toast('Error in fetching data', { variant: 'error' });
      setTotalStocks({ loading: false, data: [] });
    }
  };

  const handleServiceSelection = async (row) => {
    console.log('HELLLO ROW MEDICINE', row);
    setValue('medicine', row?.product?.main?.name);
    await fetchStock(row?.product?._id);
    setValue('conversion', row?.conversion);
    setValue('stock', totalStocks);
  };

  useEffect(() => {
    if (totalStocks !== undefined) {
      setValue('stock', totalStocks); // Set stock value after totalStocks is updated
    }
  }, [totalStocks]); // This will run whenever totalStocks changes

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Billing Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
        <MuiTextField
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root': {
              padding: '0'
            },
            '& .MuiOutlinedInput-input': {
              padding: '8px 14px'
            }
          }}
          label="Search Medicine"
          variant="outlined"
          value={inputs}
          onChange={handleChange}
          InputProps={{
            style: {
              fontSize: '12px',
              fontWeight: 600
            }
          }}
        />
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Box
          sx={{
            border: '1px solid gray',
            padding: 2,
            borderRadius: '8px',
            width: '100%',
            boxShadow: '0px 2px 10px #0099ff'
          }}
        >
          <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
            <Grid
              item
              xs={6}
              sx={{
                height: '100%',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: 1
              }}
            >
              <Table
                containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
                size="small"
                sx={{ fontSize: '32px' }}
                data={originalMedicineData || []}
                columns={TABLE_HEADER}
                onRowClick={handleServiceSelection}
              />
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Medicine Name</Typography>
                  <TextField sx={{ flex: 0.8 }} name="medicine" placeholder="Medicine Name" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.45, fontWeight: 700, fontSize: '1.4rem' }}>Quantity</Typography>
                  <TextField
                    sx={{ flex: 0.3 }}
                    type="number"
                    inputProps={{ min: '0' }}
                    name="quantity"
                    placeholder="Quantity"
                  />
                  <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: '1.4rem' }}>Stock</Typography>
                  <TextField sx={{ flex: 0.35 }} name="stock" placeholder="Stock" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Conversion</Typography>
                  <TextField
                    sx={{ flex: 0.8 }}
                    type="number"
                    inputProps={{ min: '0' }}
                    name="conversion"
                    placeholder="Conversion"
                  />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="40%">
                  <Button variant="contained" type="submit">
                    Add
                  </Button>
                  <Button variant="outlined" onClick={onClose} color="error">
                    Close
                  </Button>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </FormProvider>
    </Stack>
  );
};
